export function formatContactName(c: {
  firstName: string
  lastName?: string | null
}): string {
  return c.lastName ? `${c.firstName} ${c.lastName}` : c.firstName
}
